import { Helmet } from "react-helmet";
import ReportDesigner from "../components/ReportsBuilder/ReportDesigner";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslationHook } from "../hooks/UseTranslationHook";

function ReportsBuilder() {
    const navigate = useNavigate();
    const { 
        builderDSave,
        builderDSelectBasePdf,
        builderDAddPage,
        builderDRemovePage,
        builderDClearBasePdf,
        builderDAlertS,
        builderDAlertE,
        builderVAlertS,
        builderVAlertE,
    } = useTranslationHook();

    const translations = {
        builderDSave,
        builderDSelectBasePdf,
        builderDAddPage,
        builderDRemovePage,
        builderDClearBasePdf,
        builderDAlertS,
        builderDAlertE,
    };

    return (
        <Box height={'100%'} width={'100%'} p={'20px'}>
            <Helmet>
                <title>Reports Builder | DABI</title>
            </Helmet>
            <ReportDesigner navigate={navigate} translations={translations}/>
        </Box>
    );
};

export default ReportsBuilder;
